// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__DbL8u","approved":"Status_approved__1A5fy","rejected":"Status_rejected__3AhEt","expired":"Status_expired__1s-4A","label":"Status_label__L5m_6"};